var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTrafficLights(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8a7889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e566e"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 103.576,
    x2: 144.307,
    xlinkHref: "#lg1",
    y1: 54.599,
    y2: 111.268
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 103.576,
    x2: 144.307,
    xlinkHref: "#lg1",
    y1: 203.69,
    y2: 260.359
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 103.576,
    x2: 144.307,
    xlinkHref: "#lg1",
    y1: 352.781,
    y2: 409.45
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientTransform: "matrix(-1 0 0 1 -896.196 0)",
    gradientUnits: "userSpaceOnUse",
    x1: -1302.62,
    x2: -1261.889,
    xlinkHref: "#lg1",
    y1: 54.599,
    y2: 111.268
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientTransform: "matrix(-1 0 0 1 -896.196 0)",
    gradientUnits: "userSpaceOnUse",
    x1: -1302.62,
    x2: -1261.889,
    xlinkHref: "#lg1",
    y1: 203.69,
    y2: 260.359
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientTransform: "matrix(-1 0 0 1 -896.196 0)",
    gradientUnits: "userSpaceOnUse",
    x1: -1302.62,
    x2: -1261.889,
    xlinkHref: "#lg1",
    y1: 352.781,
    y2: 409.45
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6e566e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2944,
    stopColor: "#674d66",
    stopOpacity: 0.294
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593b56"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 421.811,
    x2: 350.975,
    xlinkHref: "#lg2",
    y1: 116.872,
    y2: 104.476
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 421.811,
    x2: 350.975,
    xlinkHref: "#lg2",
    y1: 265.966,
    y2: 253.569
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 421.811,
    x2: 350.975,
    xlinkHref: "#lg2",
    y1: 415.056,
    y2: 402.66
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 124.803,
    x2: 428.548,
    xlinkHref: "#lg1",
    y1: 124.803,
    y2: 428.548
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 320.538,
    x2: 139.523,
    xlinkHref: "#lg1",
    y1: 149.447,
    y2: -31.568
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 313.65,
    x2: 239.65,
    xlinkHref: "#lg2",
    y1: 172.993,
    y2: -6.134
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 224.344,
    x2: 295.864,
    y1: 53.252,
    y2: 124.773
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f82814"
  }))), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.678,
    x2: 229.982,
    y1: 92.052,
    y2: 24.757
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0272d"
  }))), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg1",
    y1: 11.331,
    y2: 67.732
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 320.538,
    x2: 139.523,
    xlinkHref: "#lg1",
    y1: 313.297,
    y2: 132.282
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 313.65,
    x2: 239.65,
    xlinkHref: "#lg2",
    y1: 336.843,
    y2: 157.716
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 224.344,
    x2: 295.864,
    y1: 217.102,
    y2: 288.622
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#ffcd3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#ffad2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa325"
  }))), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.678,
    x2: 229.982,
    y1: 255.901,
    y2: 188.607
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6519,
    stopColor: "#f67150",
    stopOpacity: 0.652
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7044"
  }))), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg1",
    y1: 175.181,
    y2: 231.581
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 320.538,
    x2: 139.523,
    xlinkHref: "#lg1",
    y1: 477.146,
    y2: 296.131
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg2",
    y1: 476.194,
    y2: 499.284
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 309.865,
    x2: 217.971,
    xlinkHref: "#lg2",
    y1: 488.043,
    y2: 275.016
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 224.344,
    x2: 295.864,
    y1: 380.951,
    y2: 452.472
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bada00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3706,
    stopColor: "#b8d800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#b2d000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7133,
    stopColor: "#a6c300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8428,
    stopColor: "#97b000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9575,
    stopColor: "#829700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#798c00"
  }))), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.777,
    x2: 226.54,
    y1: 429.743,
    y2: 309.322
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a6313",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#544f43"
  }))), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg1",
    y1: 339.03,
    y2: 395.431
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m55.997 60.029c0 4.676 3.024 8.815 7.479 10.236l.749.239c19.542 6.233 32.808 24.389 32.808 44.9 0 26.029 21.1 47.129 47.129 47.129h16.756v-113.247h-94.177c-5.934 0-10.744 4.81-10.744 10.743z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.997 209.12c0 4.676 3.024 8.815 7.479 10.236l.749.239c19.542 6.233 32.808 24.389 32.808 44.9 0 26.029 21.1 47.129 47.129 47.129h16.756v-113.248h-94.177c-5.934 0-10.744 4.81-10.744 10.744z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.997 358.21c0 4.676 3.024 8.815 7.479 10.236l.749.239c19.542 6.233 32.808 24.389 32.808 44.9 0 26.029 21.1 47.129 47.129 47.129h16.756v-113.247h-94.177c-5.934 0-10.744 4.81-10.744 10.743z",
    fill: "url(#SVGID_3_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m454.003 60.029c0 4.676-3.024 8.815-7.479 10.236l-.749.239c-19.542 6.233-32.808 24.389-32.808 44.9 0 26.029-21.1 47.129-47.129 47.129h-16.756v-113.247h94.177c5.934 0 10.744 4.81 10.744 10.743z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m454.003 209.12c0 4.676-3.024 8.815-7.479 10.236l-.749.239c-19.542 6.233-32.808 24.389-32.808 44.9 0 26.029-21.1 47.129-47.129 47.129h-16.756v-113.248h94.177c5.934 0 10.744 4.81 10.744 10.744z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m454.003 358.21c0 4.676-3.024 8.815-7.479 10.236l-.749.239c-19.542 6.233-32.808 24.389-32.808 44.9 0 26.029-21.1 47.129-47.129 47.129h-16.756v-113.247h94.177c5.934 0 10.744 4.81 10.744 10.743z",
    fill: "url(#SVGID_6_)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m416.781 96.839c-2.47 5.747-3.816 12.042-3.816 18.568 0 13.016-5.277 24.793-13.804 33.319-8.527 8.527-20.303 13.804-33.32 13.804h-16.762v-113.248h20.144z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m416.781 245.933c-2.47 5.747-3.816 12.042-3.816 18.568 0 13.016-5.277 24.793-13.804 33.319-8.527 8.527-20.303 13.804-33.32 13.804h-16.762v-113.249h20.144z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m416.781 395.024c-2.47 5.747-3.816 12.042-3.816 18.568 0 13.016-5.277 24.793-13.804 33.319-8.527 8.527-20.303 13.804-33.32 13.804h-16.762v-113.249h20.144z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m331.272 510h-152.544c-20.96 0-37.952-16.992-37.952-37.952v-434.096c.001-20.96 16.992-37.952 37.952-37.952h152.543c20.96 0 37.952 16.992 37.952 37.952v434.096c0 20.96-16.991 37.952-37.951 37.952z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 83.909,
    fill: "url(#SVGID_11_)",
    r: 72.577
  }), /*#__PURE__*/React.createElement("path", {
    d: "m369.223 89.799-58.132-58.132c-13.994-15.022-33.94-22.656-56.091-22.656-36.048 0-64.51 23.109-72.703 56.633-1.071 4.382-.643 8.638 3.037 10.57l183.889 183.889z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 83.909,
    fill: "url(#SVGID_13_)",
    r: 57.773
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 26.136c-31.907 0-57.773 25.866-57.773 57.773 0 1.475.073 2.932.182 4.38l53.211 53.211c1.447.109 2.905.182 4.38.182 31.907 0 57.773-25.866 57.773-57.773s-25.866-57.773-57.773-57.773z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m189.724 77.297c4.307 0 8.132-2.897 9.149-7.082 6.149-25.296 28.939-44.079 56.126-44.079s49.978 18.783 56.126 44.079c1.017 4.186 4.842 7.082 9.149 7.082 6.11 0 10.648-5.718 9.198-11.653-8.191-33.524-38.424-58.404-74.472-58.404s-66.281 24.88-74.474 58.404c-1.45 5.935 3.089 11.653 9.198 11.653z",
    fill: "url(#SVGID_15_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 247.758,
    fill: "url(#SVGID_16_)",
    r: 72.577
  }), /*#__PURE__*/React.createElement("path", {
    d: "m369.223 253.648-58.132-58.132c-13.995-15.022-33.94-22.656-56.091-22.656-36.048 0-64.51 23.109-72.703 56.633-1.071 4.382-.643 8.638 3.037 10.57l183.889 183.889z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 247.758,
    fill: "url(#SVGID_18_)",
    r: 57.773
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 189.985c-31.907 0-57.773 25.866-57.773 57.773 0 1.475.073 2.932.182 4.38l53.211 53.211c1.447.109 2.905.182 4.38.182 31.907 0 57.773-25.866 57.773-57.773s-25.866-57.773-57.773-57.773z",
    fill: "url(#SVGID_19_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m189.724 241.147c4.307 0 8.132-2.897 9.149-7.082 6.149-25.296 28.939-44.079 56.126-44.079s49.978 18.783 56.126 44.079c1.017 4.186 4.842 7.082 9.149 7.082 6.11 0 10.648-5.718 9.198-11.653-8.191-33.524-38.424-58.404-74.472-58.404s-66.281 24.88-74.474 58.404c-1.45 5.934 3.089 11.653 9.198 11.653z",
    fill: "url(#SVGID_20_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 411.608,
    fill: "url(#SVGID_21_)",
    r: 72.577
  }), /*#__PURE__*/React.createElement("path", {
    d: "m140.777 469.381v2.667c0 20.96 16.992 37.952 37.952 37.952h152.543c20.96 0 37.952-16.992 37.952-37.952v-2.667z",
    fill: "url(#SVGID_22_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m369.223 417.498-58.132-58.132c-13.995-15.022-33.94-22.656-56.091-22.656-36.048 0-64.51 23.109-72.703 56.633-1.071 4.382-.643 8.638 3.037 10.57l106.087 106.087h39.85c20.96 0 37.952-16.992 37.952-37.952z",
    fill: "url(#SVGID_23_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 411.608,
    fill: "url(#SVGID_24_)",
    r: 57.773
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 353.835c-31.907 0-57.773 25.866-57.773 57.773 0 1.475.073 2.932.182 4.38l53.211 53.211c1.447.109 2.905.182 4.38.182 31.907 0 57.773-25.866 57.773-57.773s-25.866-57.773-57.773-57.773z",
    fill: "url(#SVGID_25_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m189.724 404.996c4.307 0 8.132-2.897 9.149-7.082 6.149-25.296 28.939-44.079 56.126-44.079s49.978 18.783 56.126 44.079c1.017 4.186 4.842 7.082 9.149 7.082 6.11 0 10.648-5.718 9.198-11.653-8.193-33.524-38.426-58.404-74.474-58.404s-66.281 24.88-74.474 58.404c-1.448 5.935 3.091 11.653 9.2 11.653z",
    fill: "url(#SVGID_26_)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrafficLights);
export default __webpack_public_path__ + "static/media/icon-traffic-lights.cd35598fab06e16afe1098cba8239204.svg";
export { ForwardRef as ReactComponent };